import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Determine whether the given `functionToCheck` is a Promise.
 * @param {*} functionToCheck
 * @returns a function correctly typed as Promise
 */
export function isPromise(functionToCheck) {
  if (!functionToCheck || !(typeof functionToCheck.then === "function")) throw new Error("The provide function is not a promise");
  return functionToCheck;
}
export function debounce(timeout, func) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      timeout.id && clearTimeout(timeout.id);
      timeout.id = setTimeout(() => {
        try {
          var res = func(...args);
          resolve(res);
        } catch (err) {
          reject(err);
        }
      }, timeout.delay);
    });
  };
}